/* eslint-disable @typescript-eslint/no-explicit-any */

interface Data {
  [key: string]: any;
}

/**
 * Gets a value from a nested object or array based on a path string.
 * @param data - The object or array to get the value from.
 * @param path - The path to the value to get, using dot notation.
 * @returns The value at the given path, or undefined if the path doesn't exist.
 */
export function getData<T extends Data, R = any>(data?: T, path?: string): R | undefined {
  if (!path || !data) return undefined;

  const parts = path.split('.');
  let current: any = data;

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];

    if (current === null || current === undefined) {
      return undefined;
    }

    if (Array.isArray(current) && part === 'length') {
      return current.length as R;
    }

    current = current[part];
  }

  return current as R;
}

